import { useMutation } from "@apollo/client/react"; import React, { memo, useState, useMemo, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { CustomButton } from '../../../../../components/customButton/CustomButton';
import { RenderInputByTypeMobile } from '../../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { CustomDialog } from '../../../../../components/customDialog/CustomDialog';
import toast from 'react-hot-toast';
import { RECHAZAR_RECLAMO } from '../../../../../data/graphQL/mutations/Reclamo/RechazarReclamo';
import { DESESTIMAR_RECLAMO } from '../../../../../data/graphQL/mutations/Reclamo/DesestimarReclamo';

const RechazoModal = memo(({
  isRechazoParcial,
  disabled,
  idGestionReclamo,
  isReclamo
}) => {

  const [rechazoDescripcion, setRechazoDescripcion] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const [rechazarReclamo, { loading: rechazarLoading, data: rechazarReclamoData }] = useMutation(RECHAZAR_RECLAMO);

  const [desestimarReclamo, { loading: desestimarLoading, data: desestimarReclamoData }] = useMutation(DESESTIMAR_RECLAMO);

  useEffect(() => {
    if (!rechazarReclamoData) return;

    toast.success(`${isReclamo ? 'Reclamo' : 'EFI'} rechazado con éxito`);
  }, [rechazarReclamoData]);

  useEffect(() => {
    if (!desestimarReclamoData) return;

    toast.success(`${isReclamo ? 'Reclamo' : 'EFI'} desestimado con éxito`);
  }, [desestimarReclamoData]);

  const onSubmit = () => {

    if (!rechazoDescripcion?.trim()) return toast.error('Es necesario cargar una descripción.');

    if (isRechazoParcial) {
      rechazarReclamo({
        variables: {
          idGestionReclamo: idGestionReclamo,
          justificacion: rechazoDescripcion
        }
      });
    } else {
      desestimarReclamo({
        variables: {
          idGestionReclamo: idGestionReclamo,
          justificacion: rechazoDescripcion
        }
      });
    }
    handleCloseModal();
    setTimeout(() => navigate(`/calidad/${isReclamo ? 'reclamos' : 'efi'}`), 1000);
  };

  const buttonActionLoading = useMemo(() =>
    desestimarLoading ||
    rechazarLoading,
    [
      desestimarLoading,
      rechazarLoading]
  );

  return (
    <>
      <CustomButton
        label={isRechazoParcial ? 'Rechazo' : 'Desestimar'}
        loading={buttonActionLoading}
        disabled={disabled}
        onClick={handleOpenModal}
        variant='outlined' />

      <CustomDialog
        open={openModal}
        title={isRechazoParcial ? 'Rechazo' : 'Desestimar'}
        acceptText='Enviar'
        onAccept={onSubmit}
        cancelText='Cerrar'
        onCancel={handleCloseModal}
        fullWidth>

        <RenderInputByTypeMobile
          input={{
            name: 'rechazoDescripcion',
            type: 'long_string',
            displayName: isRechazoParcial ?
              'Justificación de Rechazo' :
              'Justificación Desestimación',
            required: true
          }}
          handleChange={(_, value) => setRechazoDescripcion(value)}
          value={rechazoDescripcion} />

      </CustomDialog>
    </>);

});

export default RechazoModal;